import EditIcon from '@mui/icons-material/Edit'
import React from 'react'
import { useIntl } from 'react-intl'
import DeleteIcon from '@mui/icons-material/Delete'
import ButtonGroup from './ButtonGroup'
import IconButton from './IconButton'

export type EditRemoveButtonGroupProps = {
	onEdit: () => void
	onRemove: () => void
	className?: string
}
const EditRemoveButtonGroup = ({
	onEdit,
	onRemove,
	className,
}: EditRemoveButtonGroupProps) => {
	const { formatMessage } = useIntl()
	return (
		<ButtonGroup
			className={className}
			overflowLimit={2}
			items={[
				<IconButton
					key="edit-button"
					tooltipTitle={formatMessage({ id: 'global.edit' })}
					onClick={onEdit}
				>
					<EditIcon color="primary" />
				</IconButton>,
				<IconButton
					key="remove-button"
					tooltipTitle={formatMessage({ id: 'remove_record.remove' })}
					onClick={onRemove}
				>
					<DeleteIcon color="error" />
				</IconButton>,
			]}
		/>
	)
}

export default EditRemoveButtonGroup
